export const HOME = "/sets";
/** Darkstar staff's home: the platform console (ADR-0015). */
export const STAFF_HOME = "/platform/orgs";

/** Where sign-in should send the user, from an untrusted `next` parameter. Only a path
 * on this site: `//host` and `/\host` are other sites to a browser. */
export function safeNext(raw: string | null): string {
  if (!raw || !raw.startsWith("/") || raw.startsWith("//") || raw.startsWith("/\\")) {
    return HOME;
  }
  return raw;
}

/** The sign-in page, remembering `from` unless it is the home page anyway. */
export function signInPath(from: string): string {
  return from === "/" || from === HOME ? "/sign-in" : `/sign-in?next=${encodeURIComponent(from)}`;
}

/** Where someone just signed in goes: `next` if it is on their side, else their home. */
export function landing(kind: "member" | "staff", next: string): string {
  const platform = next === "/platform" || next.startsWith("/platform/");
  if (kind === "staff") return platform ? next : STAFF_HOME;
  return platform ? HOME : next;
}
